<template>
  <div style="position: relative" class="matrix-picker-date">
    <div v-if="title">
      {{ title }}
    </div>
    <div
      style="background-color: #fff; position: relative"
      :style="{ width: width + 'px' }"
      class="form-control"
      @click="InputClick"
    >
      <div v-if="multipe">
        <el-tag
          v-for="(tag, index) in dates"
          :key="'tag' + index"
          class="mx-1"
          closable
          @close="removeTag(index)"
          type="info"
          effect="dark"
        >
          {{ Formatter_Dates(tag) }}
        </el-tag>
      </div>
      <div v-else>
        {{ Formatter_Dates(dates) }}
        <div style="font-size: 14px; float: right">
          <i class="matrix-icon-calendar"></i>
        </div>
      </div>
      <div
        style="position: absolute; bottom: -5px; left: 0"
        :style="{ width: width - 2 + 'px' }"
      >
        <el-date-picker
          v-model="value"
          type="date"
          :placeholder="placeholder"
          ref="dateRef"
          :shortcuts="shortcuts"
          :value-format="valueFormat"
          popper-class="picker-date-popper"
          class="matrix-picker-date"
          :disabled-date="disabledDate"
          :default-value="defaultValue"
        />
      </div>
    </div>
    <div :style="{ width: width + 'px' }" style="padding-top: 9px">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, unref, watch } from 'vue';
import { formatter_date } from '@/assets/js/formatter.js';

const props = defineProps({
  valueFormat: {
    type: String,
    default: 'DD/MM/YYYY',
    description: '绑定的日期格式',
  },
  format: {
    type: String,
    default: 'DD/MM/YYYY',
    description: '显示日期格式',
  },
  modelValue: {
    type: [Array, String],
    description: '绑定的值',
  },
  placeholder: {
    type: String,
    default: 'Pick a day',
  },
  width: {
    type: Number,
    default: 300,
    description: '组件宽度',
  },
  title: {
    type: String,
    description: '标题',
  },
  multipe: {
    type: Boolean,
    default: false,
    description: '是否多选',
  },
  disabledDate: {
    type: Function,
    description: '禁用日期',
  },
  defaultValue: {
    type: Date,
    description: '可选，选择器打开时默认显示的时间',
  },
});

const emits = defineEmits(['update:modelValue']);

const value = ref('');
const dates = ref([]);
const dateRef = ref();

const InputClick = () => {
  unref(dateRef)?.focus();

  var poper = document.getElementsByClassName('picker-date-popper');
  document.getElementsByClassName('picker-date-popper')[
    poper.length - 1
  ].style.width = props.width + 'px';
};

const shortcuts = [
  {
    text: 'To Be Confirmed',
    value: () => {
      if (props.multipe) {
        dates.value.push('To Be Confirmed');
      } else {
        dates.value = 'To Be Confirmed';
      }
      return 'N';
    },
  },
];

const removeTag = (index) => {
  dates.value.splice(index, 1);
};
// 格式化日期
const Formatter_Dates = (date) => {
  var value = new Date(date);
  if (value == 'Invalid Date') return date;
  return formatter_date(date, props.format);
};

watch(
  () => value.value,
  (val) => {
    if (val) {
      if (val != new Date('invalid')) {
        if (props.multipe) {
          dates.value.push(val);
        } else {
          dates.value = value.value;
        }
        value.value = '';
      }

      emits('update:modelValue', dates.value);
    }
  }
);

watch(
  () => props.modelValue,
  (val) => {
    if (val) {
      dates.value = val;
    }
  },
  { immediate: true }
);
</script>
<style>
.matrix-picker-date .el-input__wrapper input {
  height: 0px;
  background: none;
  width: 0px;
  padding: 0;
}
.matrix-picker-date .el-input__wrapper {
  height: 0px;
  width: 0px;
  padding: 0;
}
.matrix-picker-date.el-input {
  height: 0px !important;
  width: 0px !important;
  padding: 0;
  border: 0;
}
.matrix-picker-date .el-input__prefix {
  display: none;
}
.picker-date-popper {
  min-width: 301px !important;
}
.picker-date-popper .el-picker-panel__body-wrapper .el-picker-panel__sidebar {
  width: 100%;
  top: unset;
  margin-bottom: 10px;
}

.picker-date-popper
  .el-picker-panel__body-wrapper
  .el-picker-panel__sidebar
  button {
  width: 130px;
  height: 40px;
  border-radius: 6px;
  background-color: #3182ce;
  color: #fff;
  text-align: center;
  margin: 0 auto;
}

.picker-date-popper .el-picker-panel__body-wrapper .el-picker-panel__body {
  margin-left: 0px;
  margin-bottom: 45px;
}
.picker-date-popper .el-picker-panel.el-date-picker {
  width: 100%;
}
.picker-date-popper .el-date-picker .el-picker-panel__content {
  width: 97%;
}
.picker-date-popper th {
  text-align: center;
}

.matrix-picker-date .form-control {
  border-color: #25304c;
  border-radius: 0.4285rem;
  font-size: 0.7500000025rem;
  transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out,
    background-color 0.3s ease-in-out;
  min-height: calc(2.249999625rem + 2px);
  height: auto;
}
</style>
